export default "__VITE_ASSET__c05f19b6__"